// extracted by mini-css-extract-plugin
module.exports = {"link":"KontaktOssKanalLenkebase_link__ODgc8"};